export default __webpack_public_path__ + "static/media/5.a7123966.png";